// Les abonnements qu'on peut avoir : chacun a son nom dans le budget, et leur total fait la ligne « Abonnements ».
import type { TextKey } from './fr';
import type { SubscriptionId } from '../engine/state';

export interface SubscriptionDef {
  label: TextKey;
  /** Une plateforme de séries : c'est elle que visent les hausses de prix du streaming. */
  streaming?: boolean;
}

export const SUBSCRIPTIONS: Record<SubscriptionId, SubscriptionDef> = {
  musique: { label: 'sub.musique' },
  series: { label: 'sub.series', streaming: true },
  appli_sport: { label: 'sub.appli_sport' },
  magazine: { label: 'sub.magazine' },
  autres: { label: 'sub.autres' },
  nouvelle_plateforme: { label: 'sub.nouvelle_plateforme', streaming: true },
  salle_de_sport: { label: 'sub.salle_de_sport' },
  box_soins: { label: 'sub.box_soins' },
  passe_jeu: { label: 'sub.passe_jeu' },
  cinema: { label: 'sub.cinema' },
  yoga: { label: 'sub.yoga' },
  escalade: { label: 'sub.escalade' },
  assurance_telephone: { label: 'sub.assurance_telephone' },
  appli_budget: { label: 'sub.appli_budget' },
  // Hors de chez les parents : entière en studio, partagée en colocation (voir game/housing.ts).
  box_internet: { label: 'sub.box_internet' },
};

/**
 * Les abonnements du départ, à 18 ans : 35 € par mois, dont deux qu'on n'utilise plus (18 €),
 * que la chasse aux économies ou la carte des abonnements oubliés permettent de retrouver.
 */
export const STARTING_SUBSCRIPTIONS: { id: SubscriptionId; amount: number; forgotten?: boolean }[] = [
  { id: 'musique', amount: 6 },
  { id: 'series', amount: 11 },
  { id: 'appli_sport', amount: 10, forgotten: true },
  { id: 'magazine', amount: 8, forgotten: true },
];
